import {NamedValue} from "@2d-front-monorepo/core";
import {JSX} from "react";
import {useControlId} from "../helpers/useControlId";
import OptionGroup from "../HtmlControls/OptionGroup";
import {MvvmControlProps} from "./MvvmControlProps";
import {useMvvmFieldSubscription} from "./MvvmDataProvider";
import {useOptionItemMap} from "./useItemMap";
import {useMvvmMultiSelection} from "./useMvvmSelection";
import {useRegisterValidation} from "./useRegisterValidation";

export interface MvvmMultiOptionGroupEntry<TValue> extends NamedValue<TValue> {
	disabled?: boolean;
}

export interface MvvmMultiOptionGroupProps<T extends object = never, TValue = never> extends MvvmControlProps<T, TValue[]> {
	items: MvvmMultiOptionGroupEntry<TValue>[];
}

export default function MvvmMultiOptionGroup<T extends object, TValue>(props: MvvmMultiOptionGroupProps<T, TValue>): JSX.Element {
	const {
		property,
		id,
		label,
		items,
		column,
		hidden,
		disabled,
		validation,
		context,
		onChange,
		onBlur
	} = props;

	const controlId = useControlId(id);
	const itemMap = useOptionItemMap(items);
	const {selectedValues, onChangeInternal} = useMvvmMultiSelection(context, property, items, onChange);

	useRegisterValidation(context, property, controlId, hidden, validation);
	useMvvmFieldSubscription(context, property);

	if (hidden) {
		return <></>;
	}

	return <OptionGroup label={label}
	                    name={controlId}
	                    items={itemMap}
	                    values={selectedValues}
	                    disabled={disabled}
	                    column={column}
	                    multiple={true}
	                    onChange={onChangeInternal}
	                    onBlur={onBlur}/>;
}
